// @flow

import {
  SET_LOOM_STATUS,
  ADD_EDITOR_RECOVERY_DATA,
  CLEAR_EDITOR_RECOVERY_DATA,
  INSERT_LOOM,
  LOOM_INSERTION_COMPLETE
} from '../actions/loom'

type Selection = {
  blockIndex: number,
  offset: number
}

type Recovery = {
  content: string,
  selection: ?Selection
}

type State = {
  active: boolean,
  sessionId: ?string,
  recovery: ?Recovery,
  videoData: ?Object
}

const initialState: State = {
  active: false,
  sessionId: null,
  recovery: null,
  videoData: null
}

export function loom(state: State = initialState, action: Object): Object {
  let baseState = state
  if (state.sessionId !== action.sessionId) { // New session, clear any existing data
    baseState = {
      ...initialState,
      sessionId: action.sessionId,
    }
  }

  switch (action.type) {
    case SET_LOOM_STATUS:
      return {
        ...baseState,
        active: action.active
      }

    case ADD_EDITOR_RECOVERY_DATA:
      return {
        ...baseState,
        recovery: action.recovery
      }
    
    case CLEAR_EDITOR_RECOVERY_DATA:
      return {
        ...state,
        recovery: null
      }

    case INSERT_LOOM:
      return {
        ...baseState,
        videoData: action.videoData
      }
      
    case LOOM_INSERTION_COMPLETE:
      return initialState

    default:
      return state
  }
}
